import { markRaw } from 'vue'

const registry = new Map()

export function registerFieldType(type, config) {
	if (!type) return

	if (registry.has(type)) {
		console.warn(`[VuForm] field type "${type}" already registered`)
	}

	registry.set(type, {
		...config,
		component: markRaw(config.component)
	})
}

export function getFieldType(type) {
	return registry.get(type)
}

export function hasFieldType(type) {
	return registry.has(type)
}